module.exports = "/_next/static/images/b694bae745168c330257ba40d865f2d0-perks-md-2x.jpg.webp";